export default {
  init() {
    // Filter products when selecting a hotspot
    $(".hotspot").click(function () {
      let category = $(this).data("category");
      $(".products .product").each(function () {
        $(this).hide();
        let product = $(this).data("product");
        if (product == category) {
          $(this).show();
        }
      });
    });

    // Show all products
    $("#all-products").click(function (e) {
      e.preventDefault();
      $("#products .product").each(function () {
        $(this).fadeIn();
      });
      $(".cleanstart-headers img").each(function () {
        let headerImage = $(this).data("section");
        $(this).hide();
        if (headerImage === "all") {
          $(this).show();
        }
      });
    });

    // Change filter text depending on screen size
    $(window).on("load resize", function () {
      const showText = $("#hide-filters").data("show-text");
      $("#hide-filters").text(showText);
    });

    function showReleventProducts(self) {
      let filterBy = $.trim(self.data("filter").replace(/,/g, ""));
      $("#products .product").each(function () {
        let filter = $(this).data("filters");
        filter = filter.split(",");
        if (jQuery.inArray(filterBy, filter) !== -1) {
          $(this).show();
        } else {
          $(this).fadeOut();
        }
      });
    }

    // Show/Hide filters
    $("#hide-filters").click(function (e) {
      e.preventDefault();
      const showText = $("#hide-filters").data("show-text");
      const hideText = $("#hide-filters").data("hide-text");
      if ($(this).text() == hideText) {
        $(this).text(showText);
        $("#filters").hide();
        $("#products").attr("class", "col-lg-12");
        $("#products .product").each(function () {
          $(this).fadeIn();
          $(this).removeClass("col-xl-4");
        });
      } else {
        $(this).text(hideText);
        $("#filters").show();
        $("#products").attr("class", "col-lg-12 col-xl-9");
        $("#products .product").addClass("col-xl-4");
      }
    });

    $(".product-filter").click(function (e) {
      e.preventDefault();
    });

    // Toggle filter menu iltems
    $("li.title").click(function () {
      let section = $(this).data("title");
      $(".cleanstart-headers img").each(function () {
        let headerImage = $(this).data("section");
        $(this).hide();
        if (section === headerImage) {
          $(this).show();
        }
      });

      if ($(this).next(".items").length > 0) {
        $(this).next(".items").slideToggle();
        $(this).next(".items").removeClass("items-open");
        $(this).find("i").toggleClass("flip");
      } else {
        showReleventProducts($(this));
      }
    });

    $(".product-filter .items a").click(function () {
      showReleventProducts($(this));
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cleanstart.js